import script from "./Stories-item.vue?vue&type=script&setup=true&name=src%2Fcomponents%2FstoriesList.vue&lang=js"
export * from "./Stories-item.vue?vue&type=script&setup=true&name=src%2Fcomponents%2FstoriesList.vue&lang=js"

import "./Stories-item.vue?vue&type=style&index=0&id=1684de8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1684de8c"]])

export default __exports__